export default {"src":"/sitetest/_next/static/media/three_nav_icon.315191b1.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};